import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "sonner";
import "./i18n";
import "@/App.css";

import { AuthProvider } from "./contexts/AuthContext";
import { CheckoutProvider } from "./contexts/CheckoutContext";
import { AuditorTabsProvider } from "./contexts/AuditorTabsContext";
import CheckoutModal from "./components/CheckoutModal";
import AppShell from "./components/AppShell";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Auditor from "./pages/Auditor";
import Billing from "./pages/Billing";
import History from "./pages/History";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, scale: 0.98, filter: "blur(6px)" }}
        animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
        exit={{ opacity: 0, scale: 0.98, filter: "blur(6px)" }}
        transition={{ duration: 0.32, ease: [0.22, 0.9, 0.36, 1] }}
        data-testid="page-transition"
      >
        <Routes location={location}>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/auditor" element={<ProtectedRoute><Auditor /></ProtectedRoute>} />
          <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
          <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

function App() {
  return (
    <AuthProvider>
      <CheckoutProvider>
        <AuditorTabsProvider>
          <BrowserRouter>
            <AppShell>
              <AnimatedRoutes />
            </AppShell>
            {/* Global modal + toasts */}
            <CheckoutModal />
            <Toaster position="top-center" richColors theme="dark" closeButton />
          </BrowserRouter>
        </AuditorTabsProvider>
      </CheckoutProvider>
    </AuthProvider>
  );
}

export default App;
